import { apiFetch } from './apiFetch';
import type { StaffProfile } from '@salaries/shared';

/** One staff member's tracked flag + tax classification + bank details. */
export async function getStaffProfile(id: number): Promise<StaffProfile> {
  return apiFetch<StaffProfile>(`/salary-settings/${id}/profile`);
}

export async function updateStaffProfile(id: number, profile: StaffProfile): Promise<StaffProfile> {
  return apiFetch<StaffProfile>(`/salary-settings/${id}/profile`, {
    method: 'PUT',
    body: JSON.stringify(profile),
  });
}
